export default "__VITE_ASSET__DmDZX3k9__"